<!--
Event manager

Uses an API from the event manager plugin to get event or instance availability & eligibility

Works in three steps:
	1) Go to the vue store and request the availability data
		- this done in the vue store so if another component has already requested the data, we dont have to make another api call
	2) Use that data to calculate availability & eligibility, and set them as strings
	3) When both functions are done, we can run any other function
		- in boiler this sets the button text/state/url
		- this is set in a watch function
-->
<template>
	<span v-html="text" :class="[baseClass, indicatorClass]" v-if="text"></span>
</template>
<script>
	export default {
		name: "emButton",

		data: function () {
			return {
				text: "",
				indicatorClass: "",
			};
		},

		props: {
			dataReady: {
				type: Boolean,
				default: false,
			},
			availability: {
				type: String,
			},
			baseClass: {
				type: String,
				default: "c-availability-indicator",
			},
		},

		async mounted() {},

		methods: {
			setIndicatorAttributes() {
				const self = this;

				// if (self.availability == "soldOut") {
				// 	self.text = "Sold Out";
				// 	self.indicatorClass = baseClass + "--grey";
				// }
				if (self.availability == "Low availability") {
					self.text = "Low availability";
					self.indicatorClass = self.baseClass + "--red";
				}

				if (self.availability == "Selling fast") {
					self.text = "Selling Fast";
					self.indicatorClass = self.baseClass + "--yellow";
				}

				if (self.availability == "available") {
					self.text = "Good availability";
					self.indicatorClass = self.baseClass + "--green";
				}
			},
		},

		watch: {
			dataReady(value) {
				if (value) {
					this.setIndicatorAttributes();
				}
			},
		},
	};
</script>
